exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".shortcut-table[data-v-47eba7b5] .byted-table table tr td .bui-table-ceil,.shortcut-table[data-v-47eba7b5] .byted-table table tr th .bui-table-ceil{padding:9px 16px !important}\n", ""]);

